import React from "react"
import { Button, Modal, Form } from "react-bootstrap"

const PeriodoModal = (props) => {
  const cerrar = () => {
    props.Cerrar()
  }

  const guardar = () => {
    let nuevoPeriodo = document.getElementById("periodo").value
    if (nuevoPeriodo !== props.periodo) {
      props.CambiarPeriodo(nuevoPeriodo)
      props.Cerrar()
    } else {
      props.Cerrar()
    }
  }

  const handlePeriodoChange = (value) => {
    guardar()
  }

  let years = []
  let start = new Date().getFullYear()
  start++
  for (let i = 0; i < 10; i++) {
    years.push(start - i)
  }
  return (
    <div>
      <Modal show={props.show} onHide={cerrar}>
        <Modal.Header>Cambiar período</Modal.Header>
        <Modal.Body>
          <Form.Select
            name="periodo"
            id="periodo"
            value={props.periodo}
            onChange={handlePeriodoChange}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Form.Select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={guardar}>
            Guardar cambios
          </Button>
          <Button variant="secondary" onClick={cerrar}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default PeriodoModal
